/**
 * Safely converts an unknown caught value to an Error object.
 * Use in catch blocks to get typed error access without `as any`.
 *
 * @example
 * try { ... } catch (err) {
 *   const error = toError(err);
 *   logger.error(error.message);
 * }
 */
export const toError = (err: unknown): Error => {
  if (err instanceof Error) return err;
  if (typeof err === 'string') return new Error(err);
  if (typeof err === 'object' && err !== null && 'message' in err) {
    return new Error(String((err as { message: unknown }).message));
  }
  return new Error(String(err));
};
